import { registerBlockType } from "@wordpress/blocks";
import {
  useBlockProps,
  MediaUpload,
  MediaUploadCheck} from "@wordpress/block-editor";
import { Button, PanelBody } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

registerBlockType("monfort/brandlogo-carousel", {
  title: __("Monfort Brand Logo Carousel", "monfort"),
  icon: "images-alt2",
  category: "layout",
  attributes: {
    logos: {
      type: "array",
      default: [],
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { logos } = attributes;

    const onSelectImages = (images) => {
      const mappedImages = images.map((img) => ({
        id: img.id,
        url: img.url,
        alt: img.alt,
        link: "",
      }));
      setAttributes({ logos: mappedImages });
    };

    return (
      <div {...useBlockProps()}>
        <PanelBody title="Liens des logos de marque" initialOpen={true}>
        <MediaUploadCheck>
          <MediaUpload
            onSelect={onSelectImages}
            allowedTypes={["image"]}
            multiple
            value={logos.map((img) => img.id)}
            render={({ open }) => (
              <Button onClick={open} variant="primary">
                {logos.length > 0
                  ? __("Modifier les logos", "monfort")
                  : __("Téléverser des logos", "monfort")}
              </Button>
            )}
          />
        </MediaUploadCheck>

        {logos.length > 0 && (
          <div style={{ marginTop: "20px" }}>
            <div className="swiper brandlogo-swiper">
              <div className="swiper-wrapper">
                {logos.map((logo, index) => (
                  <div className="swiper-slide" key={index}>
                    <img src={logo.url} alt={logo.alt || ""} width={150} />
                    <input
                      type="text"
                      placeholder="Entrez l’URL du lien"
                      value={logo.link || ""}
                      onChange={(e) => {
                        const newLogos = [...logos];
                        newLogos[index].link = e.target.value;
                        setAttributes({ logos: newLogos });
                      }}
                      style={{ marginTop: "10px", width: "100%" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        </PanelBody>
      </div>
    );
  },

  save: ({ attributes }) => {
    const { logos } = attributes;
    if (!logos || logos.length === 0) {
      return null;
    }

    return (
      <div className="my-5">
        <div className="swiper brandlogo-swiper">
          <div className="swiper-wrapper">
            {logos.map((logo, index) => (
              <div className="swiper-slide" key={index}>
                {logo.link ? (
                  <a href={logo.link} target="_blank" rel="noopener noreferrer">
                    <img src={logo.url} alt={logo.alt || ""} width={150} />
                  </a>
                ) : (
                  <img src={logo.url} alt={logo.alt || ""} width={150} />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  },
});
